/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-07-11
 */

// e..g. https://s3.ap-southeast-2.amazonaws.com/syllabuswarehouseimagesdev/280cbabc-57c3-4b78-a93d-0fa04bd50e47-cfd74ce8-38b8-419c-997e-2f6f1bf7ccf0?Cache-Control=max-age%3D7776000&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAIQBJ7AWGBAZVXH3Q%2F20180711%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20180711T005023Z&X-Amz-Expires=600&X-Amz-Security-Token=FQoDYXdzECAaDJtx52hKn6pY8j%2B7ASL2ARexhJnRdbcbpHlzIj9kNGEV%2BYy2Q5URcFOVFbvdOJQML%2F9nLW4q1x1sOMepXbWt49TYda0O4jagK2dLDOGW0Rpf6UT%2FafJpCkd%2B2u1eLU8k%2BFKWyy98G%2F8RnVCP8iXTVvdDReSxBSUdBKiZ%2BsTGSIFUYXirl0TsA%2Bo0DqTS2ZFyyXqVN44zVyonUnJJo3rdsFq9eIr%2BmevHdx%2F%2BSygKobI55FZhxx1FqKOAJ7mRb%2FW9sZrPQk4WYX4B4aw2pHBLjxZkJpnkCHkcE2VwcZ8YNdwXtueNmkuZI1omQ1eLHDH6l%2BLD7xEHVfDAiUvFr4elyqT1IjtTDSj25ZTaBQ%3D%3D&X-Amz-Signature=abed07973e149ef8a3e6990c0facf8cabbbe9961d9dcf82d377548e91e1a5982&X-Amz-SignedHeaders=cache-control%3Bhost

export const DEFAULT_IMAGE_SITE = 'https://images.syllabus.seqta.com.au';

/**
 * From the upload path of an image, get the public retrieval path
 * @param imageUploadUrl The image upload URL (i.e. signed URL given by back-end, which goes direct to s3 bucket)
 * @param publicSite The base path of the public site for that s3 bucket.
 */
export const getImagePublicPath = (imageUploadUrl, publicSite = (process.env.REACT_APP_IMAGE || DEFAULT_IMAGE_SITE)) => {
	const pathParts = imageUploadUrl.split('?')[0].split('/');
	return publicSite + '/' + pathParts[pathParts.length - 1];
};



// WEBPACK FOOTER //
// ./src/imageUtil.js